import { ContractPaymentPart } from 'domain/models/PaymentPartsModel'
import { FREQUENCY_PAYMENTS } from 'constants/frequency_payments'
import moment from 'moment'

export type installmentDatesProps = {
  date: Date
  amountOfDates: number
  frequency: number
}

export default function (defaultValue?: ContractPaymentPart) {
  // Arredonda em centavos (10 x 1234.56 dava 12345.599999999999).
  const multiplyValueByInstallment = (
    installments: number,
    installmentsValue: number
  ) => {
    return Math.round(installments * installmentsValue * 100) / 100
  }

  // Mesma regra do backend (contract-payment-part.service): cada vencimento é
  // o 1º + (frequência x i) meses via moment, que trava no fim do mês
  // (31/01 → 28/02 → 31/03). O setMonth acumulado empurrava para 03/03, 03/04...
  const installmentDates = ({
    date,
    amountOfDates,
    frequency = 0
  }: installmentDatesProps): string[] => {
    const dates: string[] = []
    for (let i = 1; i < amountOfDates; i++) {
      dates.push(
        moment(date)
          .add(frequency * i, 'month')
          .format('DD/MM/YYYY')
      )
    }
    return dates
  }

  const createInitialStateInstallments = () => {
    return defaultValue?.installments || 0
  }
  const createInitialStateInstallmentsValue = () => {
    return defaultValue?.installment_value || 0
  }

  const createInitialStateDate = () => {
    return (
      (defaultValue?.first_due_date &&
        new Date(defaultValue?.first_due_date)) ||
      new Date()
    )
  }

  const createInitialStateFrequency = () => {
    return (
      (defaultValue?.frequency &&
        Number(FREQUENCY_PAYMENTS[defaultValue?.frequency])) ||
      0
    )
  }
  const createInitialStateTotalValue = () => {
    return defaultValue?.total_value || 0
  }
  return {
    installmentDates,
    multiplyValueByInstallment,
    createInitialStateInstallments,
    createInitialStateInstallmentsValue,
    createInitialStateDate,
    createInitialStateFrequency,
    createInitialStateTotalValue
  }
}
